import { projectFirestore } from '@/firebase/config';
import { ref } from 'vue';

const getProject = (id) => {
  const project = ref(null);
  const error = ref(null);

  const load = async () => {
    try {
      const res = await projectFirestore.collection('projects').doc(id).get();

      project.value = { ...res.data(), id: res.id };
    } catch (err) {
      error.value = err.message;
    }
  };

  return { project, error, load };
};

export default getProject;
